export const CHART_OPTIONS = [
    { value: "clicks", label: "Clicks" },
    { value: "conversion", label: "Conversions" },
    { value: "generated", label: "Generated" },
    { value: "cost", label: "Cost" },
];